import { FieldValues, UseFormReturn } from "react-hook-form";
import HookUploadFiles from "./hook-multiple-files/HookUploadFiles";
import HookUploadOneFile from "./HookUploadOneFile";
import {
  FieldTypes,
  IField,
} from "@/api/AppApi/services/builder/interfaces/interfaces";
import RequiredStar from "@/app/components/lib/RequiredStar";

interface Props {
  field: IField;
  form: UseFormReturn<FieldValues, any>;
}
const HookUpload: React.FC<Props> = ({ form, field }) => {
  const fConfig = field.configurations;
  return (
    <div className="w-100">
      {!fConfig.hideLabel && (
        <RequiredStar title={fConfig.title} isRequired={fConfig.is_required} />
      )}

      {fConfig.type === FieldTypes.file ? (
        <HookUploadOneFile form={form} field={field} />
      ) : (
        <HookUploadFiles form={form} field={field} />
      )}
    </div>
  );
};

export default HookUpload;
